import { useContext, useEffect } from "react";
import { useWatch } from "react-hook-form";
import { Alert, Box } from "@mui/material";
import { RecordContext } from "../../components/record/Record";
import { ScheduledTasksGroups } from "./ScheduledTasksGroups";
import { MonthdaysCapWarning } from "./MonthdaysCapWarning";
import { ScheduleSummary } from "./ScheduleSummary";
import { allDayFields, dayFieldsByFrequency, scheduledTasksOptions } from "./scheduledTasksOptions";
import { useUser } from "../../api/useAuth";
import { DEPARTMENT_FIELD, getAllowedDepartments } from "./departmentAccess";

export const ScheduledTasksForm = () => {
	const context = useContext(RecordContext);
	const entityForm = context?.entityForm;
	const item = context?.item;
	const { data: user } = useUser();

	const allowedDepartments = getAllowedDepartments(user?.role?.id);
	const defaultDepartment = allowedDepartments.length === 1 ? allowedDepartments[0] : undefined;

	const watchedFrequency = useWatch({ control: entityForm?.control, name: "run_at_frequency" });
	const frequency = watchedFrequency ?? item?.run_at_frequency;
	const visibleDayFields = dayFieldsByFrequency[frequency] || [];

	useEffect(() => {
		if (!entityForm) return;
		allDayFields.forEach((fieldName) => {
			if (visibleDayFields.includes(fieldName)) return;
			const currentValue = entityForm.getValues(fieldName);
			const hasValue = Array.isArray(currentValue)
				? currentValue.length > 0
				: currentValue != null && currentValue !== "";
			if (hasValue) entityForm.setValue(fieldName, [], { shouldDirty: true });
		});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [frequency, entityForm]);

	if (!context || !entityForm) return null;

	const baseGroupsOptions = scheduledTasksOptions.groupsOptions;

	const dynamicGroupsOptions = {
		...baseGroupsOptions,
		fieldsWithExtraOptions: [
			...(baseGroupsOptions?.fieldsWithExtraOptions ?? []),
			{ field: "run_at_frequency", defaultValue: "daily" },
			{ field: "status", defaultValue: "active" },
			{ field: DEPARTMENT_FIELD, allowedChoices: allowedDepartments, defaultValue: defaultDepartment },
			...allDayFields.map((field) => {
				const isFieldHidden = !visibleDayFields.includes(field);
				return { field, hidden: { create: isFieldHidden, update: isFieldHidden } };
			})
		]
	};

	return (
		<>
			<Box sx={{ px: 4, pt: 2, backgroundColor: "#fff" }}>
				<Alert severity="info">Tarefas novas ou atualizadas só são consideradas a partir dia seguinte.</Alert>
			</Box>
			<ScheduleSummary />
			<MonthdaysCapWarning entityForm={entityForm} frequencyItem={item?.run_at_frequency} />
			<ScheduledTasksGroups groupsOptions={dynamicGroupsOptions} />
		</>
	);
};
